/* ============================================================
   IGNITE — P8 ANGLE VIEWER  (logica)
   Vanilla JS, fara dependente. Drag desktop / swipe mobil /
   click pe thumbnails. Suporta mai multe instante pe pagina.
   ============================================================ */

(function () {
  'use strict';

  function initViewer(root) {
    var stage = root.querySelector('[data-p8-stage]');
    if (!stage) return;

    var frames = Array.prototype.slice.call(root.querySelectorAll('[data-p8-frame]'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-p8-thumb]'));
    var hint = root.querySelector('[data-p8-hint]');

    var total = frames.length;
    if (total <= 1) return; // o singura imagine: nimic de rotit

    var current = 0;

    // Cati pixeli de tras pentru a avansa un cadru.
    // Impartim latimea scenei la numarul de cadre => o "rotatie completa"
    // necesita parcurgerea intregii latimi a scenei.
    function pixelsPerFrame() {
      var w = stage.offsetWidth || 320;
      return Math.max(18, w / total);
    }

    function showFrame(index) {
      // normalizam in interval (wrap-around, ca o rotatie reala)
      index = ((index % total) + total) % total;
      if (index === current) return;

      frames[current].classList.remove('is-active');
      frames[index].classList.add('is-active');

      if (thumbs.length) {
        if (thumbs[current]) thumbs[current].classList.remove('is-active');
        if (thumbs[index]) thumbs[index].classList.add('is-active');
      }

      current = index;
    }

    function hideHint() {
      if (hint) hint.classList.add('is-hidden');
    }

    /* ---------- DRAG / SWIPE unificat prin Pointer Events ---------- */
    var dragging = false;
    var startX = 0;
    var startFrame = 0;
    var moved = false;

    function onDown(clientX) {
      dragging = true;
      moved = false;
      startX = clientX;
      startFrame = current;
    }

    function onMove(clientX) {
      if (!dragging) return;
      var dx = clientX - startX;
      if (Math.abs(dx) > 4) {
        moved = true;
        hideHint();
      }
      var step = Math.round(dx / pixelsPerFrame());
      // tragerea spre dreapta avanseaza cadrele
      showFrame(startFrame + step);
    }

    function onUp() {
      dragging = false;
    }

    // Pointer Events acopera mouse + touch + pen intr-un singur API
    if (window.PointerEvent) {
      stage.addEventListener('pointerdown', function (e) {
        stage.setPointerCapture(e.pointerId);
        onDown(e.clientX);
      });
      stage.addEventListener('pointermove', function (e) {
        if (dragging) {
          onMove(e.clientX);
        }
      });
      stage.addEventListener('pointerup', onUp);
      stage.addEventListener('pointercancel', onUp);
      stage.addEventListener('pointerleave', onUp);
    } else {
      // Fallback pentru browsere foarte vechi
      stage.addEventListener('mousedown', function (e) { onDown(e.clientX); });
      window.addEventListener('mousemove', function (e) { onMove(e.clientX); });
      window.addEventListener('mouseup', onUp);
      stage.addEventListener('touchstart', function (e) {
        onDown(e.touches[0].clientX);
      }, { passive: true });
      stage.addEventListener('touchmove', function (e) {
        onMove(e.touches[0].clientX);
      }, { passive: true });
      stage.addEventListener('touchend', onUp);
    }

    // Impiedicam selectia / drag nativ al imaginii
    stage.addEventListener('dragstart', function (e) { e.preventDefault(); });

    /* ---------- Thumbnails ---------- */
    thumbs.forEach(function (thumb, idx) {
      thumb.addEventListener('click', function () {
        hideHint();
        showFrame(idx);
      });
    });

    /* ---------- Tastatura (accesibilitate) ---------- */
    stage.setAttribute('tabindex', '0');
    stage.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        showFrame(current - 1);
        hideHint();
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        showFrame(current + 1);
        hideHint();
      }
    });
  }

  function initAll() {
    var roots = document.querySelectorAll('[data-p8-viewer]');
    Array.prototype.forEach.call(roots, initViewer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init in Theme Editor cand sectiunea e reincarcata
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-p8-viewer]');
    if (root) initViewer(root);
  });
})();